import Typography from '@mui/material/Typography';

export function BodyExtraLarge ({ children, sx }) {
  return (
    <Typography
      variant='body1'
      sx={{
        color: '#FFFFFF',
        fontFamily: 'Reckless',
        fontSize: '3rem',
        fontWeight: 300,
        lineHeight: '3.625rem',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export function BodyLarge ({ children, sx }) {
  return (
    <Typography
      variant='body1'
      sx={{
        color: '#FFFFFF',
        fontFamily: 'Reckless',
        fontSize: '2.25rem',
        fontWeight: 300,
        lineHeight: '2.7rem',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export function BodyMedium ({ children, sx }) {
  return (
    <Typography
      variant='body1'
      sx={{
        color: '#FFFFFF',
        fontFamily: 'MabryPro',
        fontSize: '1.125rem',
        fontWeight: 300,
        lineHeight: '1.375rem',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export function BodySmall ({ children, sx }) {
  return (
    <Typography
      variant='body1'
      sx={{
        color: '#FFFFFF',
        fontFamily: 'MabryPro',
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: '1.0625rem',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export function LabelSmall ({ children, sx }) {
  return (
    <Typography
      variant='body1'
      sx={{
        color: 'rgba(45, 45, 45, 0.5)',
        fontFamily: 'MabryPro',
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: '0.875rem',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}

export function HeadingMedium ({ children, sx }) {
  return (
    <Typography
      variant='body1'
      sx={{
        color: '#41434A',
        fontFamily: 'MabryPro',
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: '1.25rem',
        ...sx,
      }}
    >
      {children}
    </Typography>
  );
}


